import type { StoryType } from '@/features/story/types';
import type { ShareMode } from './variants';

/**
 * Resolve a `StoryType` to the share-sheet's variant mode.
 *
 * The only value that flips to `sb_explanation` is
 * `schlauberger_kurz_erklaert`; every other production `StoryType` — the
 * standard worlds (`standard`), SB-Sachgeschichte
 * (`schlauberger_sachgeschichte`), and the series-mode values — maps to
 * `standard`. Pipeline-internal story types (`sb_research`,
 * `sb_factcheck`, `moderation_check`) never appear on a finished Story
 * row at rest but are included in the fallback branch defensively.
 *
 * Pure function — no React state, no effects. Named file
 * `story-mode.ts` (not `useStoryMode.ts`) because it isn't a hook.
 */
export function resolveStoryMode(storyType: StoryType): ShareMode {
  return storyType === 'schlauberger_kurz_erklaert' ? 'sb_explanation' : 'standard';
}
